import * as React from 'react';
import { Box, Checkbox, InfoIcon, Text, TextButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';

export interface TooltipProps {
  tooltipText: string;
  learnMoreText: string;
  learnMoreUrl: string;
}

export interface Props {
  dataHook: string;
  initialState: boolean;
  text: string;
  tooltipProps: TooltipProps;
  onChange(enabled: boolean): void;
}

export const DeclineAllToggle: React.FunctionComponent<Props> = ({
  initialState,
  onChange,
  dataHook,
  text,
  tooltipProps,
}) => {
  const [checked, setChecked] = React.useState(initialState);
  const onCheckedChange = () => {
    const newState = !checked;
    setChecked(newState);
    onChange(newState);
  };
  const renderTooltip = () => (
    <Box direction="vertical">
      <Text light size="small" weight="normal">
        {tooltipProps.tooltipText}
      </Text>
      <TextButton
        dataHook={DataHooks.TextAndDisplayDeclineAllLearnMore}
        skin="light"
        size="small"
        weight="normal"
        underline="always"
        onClick={() => window.open(tooltipProps.learnMoreUrl, '_blank')}
      >
        {tooltipProps.learnMoreText}
      </TextButton>
    </Box>
  );
  return (
    <Box verticalAlign="middle" marginBottom={2}>
      <Checkbox checked={checked} onChange={onCheckedChange} dataHook={dataHook}>
        {text}
      </Checkbox>
      <Box marginLeft={1}>
        <InfoIcon dataHook={DataHooks.TextAndDisplayDeclineAllInfoIcon} content={renderTooltip()} />
      </Box>
    </Box>
  );
};
